export const GalleryEndpoints = {
    createGallery: {
        method: "post",
        url: "/galleries",
    },
    getAllGallery: {
        method: "get",
        url: "/galleries",
    },
    getGallery: {
        method: "get",
        url: "/galleries/:id",
    },
    updateGallery: {
        method: "put",
        url: "/galleries/:id",
    },
    deleteGallery: {
        method: "delete",
        url: "/galleries/:id",
    },
}
